"use client"

import { Helmet } from "react-helmet-async"
import { Book, Briefcase, GraduationCap, Users } from "lucide-react"

export default function FacultyPage() {
    const facultyMembers = [
        {
            id: 9,
            name: "Sujeet Sir",
            role: "Senior Mathematics Teacher",
            image: "/placeholder.svg?height=400&width=400",
            bio: "Sujeet Sir is dedicated to making mathematics engaging and accessible, with a focus on building strong foundational skills for students.",
            experience: "25 years teaching experience",
            education: [
                "B.Sc.",
                "B.Ed."
            ],
            specialization: "Mathematics, Algebra, Geometry"
        },
        // {
        //     id: 2,
        //     name: "Ravi Sir",
        //     role: "Reasoning Specialist",
        //     image: "/placeholder.svg?height=400&width=400",
        //     bio: "Ravi Sir brings a dynamic approach to teaching reasoning, helping students excel in competitive exams through logical and analytical training.",
        //     experience: "10 years teaching experience",
        //     education: [
        //         "B.Com.",
        //         "B.Tech.",
        //         "B.Ed."
        //     ],
        //     specialization: "Logical Reasoning, Analytical Reasoning"
        // },
        {
            id: 3,
            name: "Yogesh Sir",
            role: "Zoology Professor",
            image: "/placeholder.svg?height=400&width=400",
            bio: "Yogesh Sir is passionate about biological sciences, specializing in zoology and inspiring students with hands-on learning experiences.",
            experience: "16 years teaching experience",
            education: [
                "M.Sc. (Zoology)",
                "B.Ed."
            ],
            specialization: "Zoology, Ecology, Animal Physiology"
        },
        {
            id: 4,
            name: "Rohit Sir",
            role: "Physics Specialist",
            image: "/placeholder.svg?height=400&width=400",
            bio: "Rohit Sir excels in teaching physics, particularly electronics, making complex concepts relatable through practical applications.",
            experience: "15 years teaching experience",
            education: [
                "M.Sc. (Physics, Electronic Branch)",
                "B.Sc.",
                "B.Ed."
            ],
            specialization: "Electronics, Mechanics, Electromagnetism"
        },
        {
            id: 5,
            name: "Praveen Sir",
            role: "Computer Science Expert",
            image: "/placeholder.svg?height=400&width=400",
            bio: "Praveen Sir combines his technical expertise with a passion for teaching, guiding students in mastering programming and computer science concepts.",
            experience: "15 years teaching experience",
            education: [
                "MCA",
                "M.A. (Hindi)",
                "B.Sc.",
                "B.Ed."
            ],
            specialization: "Java, Python, C++, Operating Systems, Computer Networks"
        },
     
        {
            id: 7,
            name: "Mohini Ma'am",
            role: "Accountancy Teacher",
            image: "/placeholder.svg?height=400&width=400",
            bio: "Mohini Ma'am is committed to simplifying accountancy concepts, empowering students with practical skills for academic and professional success.",
            experience: "5 years teaching experience",
            education: [
                "UGC NET Commerce",
                "CA Inter",
                "M.Com.",
                "B.Ed."
            ],
            specialization: "Accountancy"
        },

    ]

    return (
        <>
        <Helmet>
            <title>Expert Faculty at SSS Achievers | Best Teachers in Ghazipur</title>
            <meta name="description" content="Meet SSS Achievers' expert faculty in Ghazipur – 7+ highly experienced teachers with 5-25 years experience in Maths, Physics, Chemistry, Biology, Commerce & more. Ghazipur's best coaching teachers." />
            <link rel="canonical" href="https://www.sssachievers.com/faculty" />
            <meta property="og:title" content="Expert Faculty at SSS Achievers | Best Teachers in Ghazipur" />
            <meta property="og:url" content="https://www.sssachievers.com/faculty" />
        </Helmet>
        <section className="py-16 px-4 bg-gradient-to-b from-white to-[#e6f7fa]">
            <div className="container mx-auto max-w-7xl">
                <div className="text-center mb-16 reveal-animation">
                    <h2 className="text-2xl md:text-4xl font-semibold mb-4 text-[#0097b2]">Our Expert Faculty</h2>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        Learn from our highly qualified educators who bring years of experience and expertise to help you excel in
                        your academic journey.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {facultyMembers.map((faculty) => (
                        <div
                            key={faculty.id}
                            className={`faculty-card bg-white rounded-xl overflow-hidden transition-all duration-500 hover:shadow-[0_0_20px_rgba(0,151,178,0.3)] transform hover:-translate-y-1 ${faculty.type === "more-faculty" ? "lg:col-span-2" : ""}`}
                        >
                            {faculty.type === "more-faculty" ? (
                                <div className="p-6 h-full flex flex-col items-center justify-center bg-gradient-to-br from-[#0097b2] to-[#007a8c] text-white">
                                    <Users className="w-12 h-12 mb-4" />
                                    <h3 className="text-xl font-bold mb-2 text-center">{faculty.name}</h3>
                                    <p className="text-sm mb-4 text-center">{faculty.role}</p>
                                    <p className="text-sm mb-6 text-center">{faculty.bio}</p>
                                    <button className="px-6 py-2 bg-white text-[#0097b2] font-semibold  hover:bg-[#e6f7fa] transition-colors duration-300 rounded">
                                        {faculty.buttonText}
                                    </button>
                                </div>
                            ) : (
                                <div className="p-6">
                                    <h3 className="text-xl font-bold text-gray-800 mb-1">{faculty.name}</h3>
                                    <p className="text-[#0097b2] font-medium mb-4">{faculty.role}</p>

                                    <div className="mb-4">
                                        <p className="text-gray-600 text-sm">{faculty.bio}</p>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex items-start gap-3">
                                            <Briefcase className="w-5 h-5 text-[#0097b2] mt-1 flex-shrink-0" />
                                            <div>
                                                <h4 className="font-semibold text-gray-700">Teaching Experience</h4>
                                                <p className="text-gray-600 text-sm">{faculty.experience}</p>
                                            </div>
                                        </div>

                                        <div className="flex items-start gap-3">
                                            <GraduationCap className="w-5 h-5 text-[#0097b2] mt-1 flex-shrink-0" />
                                            <div>
                                                <h4 className="font-semibold text-gray-700">Education</h4>
                                                <ul className="text-gray-600 text-sm space-y-1">
                                                    {faculty.education.map((edu, index) => (
                                                        <li key={index} className="flex items-start">
                                                            <span className="mr-2">•</span>
                                                            <span>{edu}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>

                                        <div className="flex items-start gap-3">
                                            <Book className="w-5 h-5 text-[#0097b2] mt-1 flex-shrink-0" />
                                            <div>
                                                <h4 className="font-semibold text-gray-700">Specialization</h4>
                                                <p className="text-gray-600 text-sm">{faculty.specialization}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            <style jsx global>{`
                .reveal-animation {
                    animation: fadeInUp 0.8s ease-out forwards;
                }
                
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                .faculty-card {
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
                    position: relative;
                }
                
                .faculty-card::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 4px;
                    background: #0097b2;
                    transform: scaleX(0);
                    transform-origin: left;
                    transition: transform 0.4s ease;
                }
                
                .faculty-card:hover::before {
                    transform: scaleX(1);
                }
                
                @media (prefers-reduced-motion: reduce) {
                    .reveal-animation {
                        animation: none;
                    }
                    
                    .faculty-card, .faculty-card::before {
                        transition: none;
                    }
                }
            `}</style>
        </section>
        </>
    )
}